import React, { useEffect, useState } from "react";
import { Form, DatePicker, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../features/fetch/fetchSlice";
import BreadCrumb from "../../layout/BreadCrumb";

const { RangePicker } = DatePicker;

function LogsHeader({ onFiltersChange }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const usersUrl = "api/v2/audit-trail/users";
  const tableUrl = "api/v2/audit-trail/tables";

  const [selectedTable, setSelectedTable] = useState(null);
  const [recordsUrl, setRecordsUrl] = useState(null);

  const { usersData, tablesData, recordsData } = useSelector((state) => ({
    usersData: state.fetch.data[usersUrl] || [],
    tablesData: state.fetch.data[tableUrl] || [],
    recordsData: recordsUrl ? state.fetch.data[recordsUrl] || [] : [],
  }));

  useEffect(() => {
    dispatch(fetchData({ url: usersUrl }));
    dispatch(fetchData({ url: tableUrl }));
  }, []);

  const fetchRecords = (tableChanged, search) => {
    if (tableChanged) {
      const url = `api/v2/audit-trail/records?tableChanged=${tableChanged}${search ? `&search=${search}` : ""}`;
      setRecordsUrl(url);
      dispatch(fetchData({ url }));
    }
  };

  const handleTableChange = (value) => {
    setSelectedTable(value);
    form.setFieldsValue({ idChanged: undefined });
    if (value) {
      fetchRecords(value);
    }
    handleFilterChange();
  };

  const handleFilterChange = () => {
    const values = form.getFieldsValue();
    notifyFiltersChange(values);
  };

  const handleClear = () => {
    form.resetFields();
    setSelectedTable(null);
    notifyFiltersChange({});
  };

  const notifyFiltersChange = (values) => {
    if (onFiltersChange) {
      const filters = {};
      if (values.userId) filters.userId = values.userId;
      if (values.tableChanged) filters.tableChanged = values.tableChanged;
      if (values.idChanged) filters.idChanged = values.idChanged;
      if (values.dateRange) {
        filters.startDate = values.dateRange[0]?.format("YYYY-MM-DD");
        filters.endDate = values.dateRange[1]?.format("YYYY-MM-DD");
      }
      onFiltersChange(filters);
    }
  };

  return ( 
    <div className="white_card w-full mt-[1.25rem]">
      <Form form={form} className="w-full">
        <div className="flex flex-col gap-[1rem]">
          <div className="flex lg:flex-row flex-col lg:items-center gap-[1rem]">
            <Form.Item name="userId" noStyle>
              <Select
                className="filter-select"
                style={{ minWidth: 200 }}
                allowClear
                showSearch
                optionFilterProp="label"
                placeholder="Select User"
                onChange={handleFilterChange}
                options={usersData?.map((user) => ({
                  value: user?.userId,
                  label: user?.userFullNames,
                }))}
              />
            </Form.Item>

            <Form.Item name="tableChanged" noStyle>
              <Select
                className="filter-select"
                style={{ minWidth: 200 }}
                allowClear
                showSearch
                optionFilterProp="label"
                placeholder="Select Table"
                onChange={handleTableChange}
                options={tablesData?.map((table) => ({
                  value: table?.tableChanged,
                  label: table?.userFriendlyTableName,
                }))}
              />
            </Form.Item>



            <Form.Item label="" name="dateRange" noStyle>
              <RangePicker
                className="filter-select"
                style={{ minWidth: 280 }}
                allowClear
                onChange={handleFilterChange}
                placeholder={["Start Date", "End Date"]}
                format="DD-MM-YYYY"
              />
            </Form.Item>
          </div>

          <div className="flex lg:flex-row flex-col lg:items-center lg:w-[50%] w-full gap-[1rem]">
            {selectedTable && (
              <Form.Item name="idChanged" noStyle className="flex-1">
                <Select
                  className="filter-select flex-1"
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  placeholder="Select record"
                  onChange={handleFilterChange}
                  options={recordsData?.map((record) => ({
                    value: record?.idChanged,
                    label: record?.recordName,
                  }))}
                />
              </Form.Item>
            )}

            <button
              type="button"
              onClick={handleClear}
              className="cstm-btn !w-fit whitespace-nowrap"
            >
              Clear Filters
            </button>
          </div>
        </div>
      </Form>
    </div> 
  );
}

export default LogsHeader;
